import { openCookieSettings } from "@/lib/cookieConsent";

export const Footer = () => {
  return (
    <footer className="border-t border-border bg-card/30 py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img
                src="/logo-provenance-icon.svg"
                alt="PROVENANCE 365"
                className="h-9 w-9 shrink-0"
              />
              <span className="font-display text-lg font-bold tracking-tight text-black">PROVENANCE 365</span>
            </div>
            <p className="text-sm text-muted-foreground max-w-md">
              Connected engineering, financial and commercial evidence for better business decisions.
              Assess risk, test assumptions and make decisions about growth, investment and deals.
            </p>
            <div className="mt-6 space-y-2 text-sm text-muted-foreground">
              <p className="flex items-center gap-2">
                <span className="font-medium text-foreground">Email:</span>
                <a href="mailto:hello@provenance365.com" className="hover:text-foreground transition-colors">
                  hello@provenance365.com
                </a>
              </p>
              <p className="text-muted-foreground/80">London, United Kingdom</p>
            </div>
          </div>

          {/* Primary navigation */}
          <div>
            <h4 className="font-display font-semibold mb-4">Explore</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><a href="/advisors" className="hover:text-foreground transition-colors">For Technical Advisers</a></li>
              <li>
                <a href="/investors" className="hover:text-foreground transition-colors">
                  For Investors
                </a>
              </li>
              <li>
                <a href="/for-founders" className="hover:text-foreground transition-colors">
                  For Founders &amp; CEOs
                </a>
              </li>
              <li>
                <a href="/security" className="hover:text-foreground transition-colors">
                  Security
                </a>
              </li>
              <li>
                <a href="/pricing" className="hover:text-foreground transition-colors">
                  Pricing
                </a>
              </li>
              <li>
                <a href="/contact" className="hover:text-foreground transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-display font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>
                <a href="/privacy" className="hover:text-foreground transition-colors">
                  Privacy policy
                </a>
              </li>
              <li>
                <a href="/terms" className="hover:text-foreground transition-colors">
                  Terms of service
                </a>
              </li>
              <li>
                <a href="/cookies" className="hover:text-foreground transition-colors">
                  Cookie policy
                </a>
              </li>
              <li>
                <button
                  type="button"
                  onClick={openCookieSettings}
                  className="hover:text-foreground transition-colors"
                >
                  Cookie settings
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">© 2026 PROVENANCE 365. All rights reserved.</p>
          <a href="/security" className="text-sm text-primary hover:underline">Inspect the processing boundary</a>
        </div>
      </div>
    </footer>
  );
};
